import {
  formatCurrency,
  formatPercent,
  overallStatusLabel,
} from "./dashboardUtils";

function SummaryCard({ label, value, helper, accent = "emerald" }) {
  const accents = {
    emerald: "from-emerald-700 to-teal-600",
    blue: "from-sky-700 to-cyan-600",
    amber: "from-amber-600 to-orange-500",
    slate: "from-slate-800 to-zinc-700",
    rose: "from-rose-700 to-red-600",
  };

  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow">
      <div className={`h-1 bg-gradient-to-r ${accents[accent]}`} />
      <div className="p-4">
        <p className="text-sm font-medium text-zinc-500">{label}</p>
        <p className="mt-2 text-2xl font-semibold text-zinc-950">{value}</p>
        {helper && <p className="mt-1 text-xs text-zinc-500">{helper}</p>}
      </div>
    </div>
  );
}

export default function DashboardSummaryCards({ data }) {
  const summary = data?.summary || {};
  const regularity = data?.regularity || {};
  const partialAndMissed =
    Number(regularity.partiallyPaidMonths || 0) +
    Number(regularity.missedMonths || 0);

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5">
      <SummaryCard
        label="Total Paid"
        value={formatCurrency(summary.totalPaid)}
        helper={`${summary.successfulTransactionCount || 0} successful payments | visible breakdown ${formatCurrency(
          summary.visibleBreakdownTotal ?? summary.totalPaid
        )}`}
        accent="slate"
      />
      <SummaryCard
        label="Membership & Ijtima Chanda Paid"
        value={formatCurrency(summary.mandatoryPaid)}
        helper={`${formatPercent(regularity.completionRate)} completion`}
      />
      <SummaryCard
        label="Fully Paid Months"
        value={`${regularity.fullyPaidMonths || 0}/${regularity.expectedMonths || 0}`}
        helper={overallStatusLabel(regularity.status)}
        accent="blue"
      />
      <SummaryCard
        label="Current Streak"
        value={`${regularity.currentStreak || 0} month${
          Number(regularity.currentStreak || 0) === 1 ? "" : "s"
        }`}
        helper={`Longest: ${regularity.longestStreak || 0}`}
        accent="amber"
      />
      <SummaryCard
        label="Missed / Partial"
        value={partialAndMissed}
        helper={`${regularity.missedMonths || 0} missed, ${
          regularity.partiallyPaidMonths || 0
        } partial`}
        accent={partialAndMissed > 0 ? "rose" : "emerald"}
      />
    </div>
  );
}
